import { render } from "./SpacComplete.vue?vue&type=template&id=77673118&scoped=true"
import script from "./SpacComplete.vue?vue&type=script&lang=js"
export * from "./SpacComplete.vue?vue&type=script&lang=js"

import "./SpacComplete.vue?vue&type=style&index=0&id=77673118&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77673118"]])

export default __exports__